import React from 'react';
import { Link } from 'react-scroll';
import { Download, ArrowRight, Code, Github, Linkedin, Mail } from 'lucide-react';

const Hero = () => {
  return (
    <section id="home" className="min-h-screen flex items-center pt-5">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="max-w-5xl mx-auto text-center">
          {/* Texte */}
          <div className="lg:w-10/11 animate-fade-in">

            <h1 className="font-bold mb-12">
              <span className="text-3xl md:text-2xl block">Bonjour, je m'appelle</span>
              <span className="gradient-text text-5xl md:text-7xl text-primary block">Yannick HIEN</span>
            </h1>
            
            <h2 className="font-bold text-2xl md:text-2xl text-gray-300 mb-10">
              Étudiant au Baccalauréat en génie informatique.
            </h2>
            
            <p className="text-gray-400 mx-auto text-center text-lg mb-10 max-w-3xl">
              Je recherche un stage qui me permettra de renforcer mes compétences tout en 
              contribuant à des projets innovants dans un environnement dynamique.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="projects"
                smooth={true}
                duration={500}
                className="inline-flex items-center justify-center gap-2 bg-primary text-white px-8 py-4 rounded-lg hover:bg-secondary transition-all hover:scale-105 cursor-pointer shadow-lg"
              >
                <Code size={20} />
                Voir mes projets
                <ArrowRight size={20} />
              </Link>
              
              <a
                href="/CV Yannick.pdf"
                className="inline-flex items-center justify-center gap-2 border border-gray-600 text-white px-8 py-4 rounded-lg hover:border-primary hover:text-primary transition-all"
                download
              >
                <Download size={20} />
                Télécharger mon CV
              </a>
            </div>

            <div className="mt-12 flex justify-center space-x-6">
              <a
                href="https://github.com/17Yannick17"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="GitHub"
              >
                <Github size={28} />
              </a>
              
              <a
                href="https://www.linkedin.com/in/yannick-hien-3a6187177"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={28} />
              </a>
              
              <a
                href="mailto:nyhien@etu.uqac.ca?subject=Contact%20depuis%20votre%20portfolio&body=Bonjour%20Yannick,"
                className="text-gray-400 hover:text-white transition-colors"
                aria-label="Email"
              >
                <Mail size={28} />
              </a>
            </div>

          </div>
          
        </div>
      </div>
    </section>
  );
};

export default Hero;